import React from 'react';

import DocumentTitle from 'bz-core-controls/controls/document-title';
import Fallback from 'bz-core-controls/controls/lazy/controls/fallback';
import { DialogStoreProvider } from 'bz-stores/mobx/dialog-store';
import { observer } from 'mobx-react';
import { Redirect, Route, Switch } from 'react-router';
import Paths from './paths';
const EstimatesDesktop = React.lazy(() => import('../desktop'));

export interface IParams {
  id: string;
}
export interface IProps {}

const EstimatesSwitch: React.FC<IProps> = observer(() => {
  return (
    <DialogStoreProvider>
      <>
        <DocumentTitle title="TM3 > Estimates" />
        <React.Suspense fallback={<Fallback />}>
          <Switch>
            <Redirect path={Paths.estimates.cloneRedirect} to={Paths.estimates.details} />
            <Route
              path={[Paths.estimates.details, Paths.estimates.index]}
              component={EstimatesDesktop}
            />
          </Switch>
        </React.Suspense>
      </>
    </DialogStoreProvider>
  );
});

export default EstimatesSwitch;
